import controllerImg from "@/assets/controller.png";
import egwImg from "@/assets/egw.png";
import multiSensorImg from "@/assets/multi-sensor.png";
import smartVueImg from "@/assets/smartvue.png";

export const markerRadius = 0.6;

export const markerColors = {
    controller: { fill: "#d0e4f7", stroke: "#4a90d9" },
    egw: { fill: "#e2d6f0", stroke: "#7b2d8e" },
    multiSensor: { fill: "#fce4ec", stroke: "#e91e63" },
    smartVue: { fill: "#e0f7fa", stroke: "#00acc1" },
};

export const selectedMarkerColor = { fill: "#53c7f7", stroke: "#2ba6d4" };

export const markerIcons = {
    controller: controllerImg,
    egw: egwImg,
    multiSensor: multiSensorImg,
    smartVue: smartVueImg,
};

export const markerTypeLabels = {
    controller: "Controller",
    egw: "EGW",
    multiSensor: "Multi-Sensor",
    smartVue: "SmartVue",
};
